module.exports = __webpack_public_path__ + "static/media/password.557d5178.svg";